export const en = {
  taskInfo: 'Task info',
  integrations: 'Integrations',
  refresh: 'refresh'
};

export type Translations = typeof en;
